import './PaginationButtons.scss';

import { useParams } from 'react-router-dom';
import Pagination from '@mui/material/Pagination';

export default function PaginationButtons({ pagination, onChangePage }) {
  const params = useParams();
  const onChange = (e, page) => {
    onChangePage(page);
  };
  return (
    <div className="flex-row pagination-buttons">
      <Pagination
        count={pagination.totalPages}
        variant="outlined"
        shape="rounded"
        onChange={onChange}
        page={+params.page}
      />
    </div>
  );
}
